import { UserMinus, Mail, Home, AlertCircle } from "lucide-react";
import { Button } from "@/components/atoms/button";
import { Card, CardContent } from "@/components/atoms/card";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function UserDeactivated() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate("/welcome");
  };

  const handleContactSupport = () => {
    // You can customize this to your support email or contact method
    window.open(
      "mailto:soporte@gonau.com?subject=Reactivación de cuenta Tower&body=Hola, mi cuenta ha sido desactivada y necesito que sea reactivada.",
      "_blank",
    );
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full">
        <Card>
          <CardContent className="pt-6">
            <div className="text-center">
              <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
                <UserMinus className="w-8 h-8 text-red-600" />
              </div>

              <h2 className="text-2xl font-semibold text-gray-900 mb-2">
                Cuenta desactivada
              </h2>

              <p className="text-gray-600 mb-6">
                Tu cuenta ha sido temporalmente desactivada. Por favor contacta
                a tu administrador para solicitar la reactivación de tu acceso.
              </p>

              <div className="space-y-3">
                <Button
                  onClick={handleContactSupport}
                  className="w-full flex items-center justify-center gap-2"
                >
                  <Mail className="w-4 h-4" />
                  Solicitar reactivación
                </Button>

                <Button
                  variant="outline"
                  onClick={handleLogout}
                  className="w-full flex items-center justify-center gap-2"
                >
                  <Home className="w-4 h-4" />
                  Cerrar sesión
                </Button>
              </div>

              <div className="mt-6 p-4 bg-amber-50 rounded-lg border border-amber-200">
                <div className="flex items-start gap-3">
                  <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
                  <div className="text-left">
                    <p className="text-sm text-amber-800">
                      <strong>¿Por qué fue desactivada mi cuenta?</strong>
                      <br />
                      Las cuentas pueden ser desactivadas por motivos de
                      seguridad, política de la empresa, o cambios en tu rol
                      laboral. Contacta a tu administrador para más información.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
